// Inspired by NextJs
// https://github.com/zeit/next.js/blob/886037b1bac4bdbfeb689b032c1612750fb593f7/packages/next/client/dev/prerender-indicator.js#L1
import { iconQuestionMark } from './icons';
export var KEY = '@layer7/mock-server/running-indicator';
/**
 * Create and display the running indicator that should be displayed when the mock server is running.
 *
 * @param {*} icon The HTML element containing the icon
 * @param {*} link The link to open when clicking on the running indicator
 */
export function initializeRunningIndicator(_a) {
    var _b = _a.icon, icon = _b === void 0 ? iconQuestionMark : _b, _c = _a.link, link = _c === void 0 ? '#' : _c;
    var shadowHost = document.createElement('div');
    shadowHost.id = KEY;
    // Make sure container is fixed and on a high zIndex so it shows
    shadowHost.style.position = 'fixed';
    shadowHost.style.bottom = '20px';
    shadowHost.style.left = '10px';
    shadowHost.style.width = 0;
    shadowHost.style.height = 0;
    shadowHost.style.zIndex = 99998;
    shadowHost.style.transition = 'all 100ms ease';
    document.body.appendChild(shadowHost);
    var shadowRoot;
    var prefix = '';
    if (shadowHost.attachShadow) {
        shadowRoot = shadowHost.attachShadow({ mode: 'open' });
    }
    else {
        // If attachShadow is undefined then the browser does not support
        // the Shadow DOM, we need to prefix all the names so there
        // will be no conflicts
        shadowRoot = shadowHost;
        prefix = "".concat(KEY, "-");
    }
    // Container
    var container = createContainer(prefix, icon, link);
    shadowRoot.appendChild(container);
    // CSS
    var css = createCss(prefix);
    shadowRoot.appendChild(css);
    var expandEl = container.querySelector('a');
    var closeEl = container.querySelector("#".concat(prefix, "close"));
    // State
    var dismissKey = KEY;
    var dismissUntil = parseInt(window.localStorage.getItem(dismissKey), 10);
    var dismissed = dismissUntil > new Date().getTime();
    var isVisible = !dismissed;
    function updateContainer() {
        if (isVisible) {
            container.classList.add("".concat(prefix, "visible"));
        }
        else {
            container.classList.remove("".concat(prefix, "visible"));
        }
    }
    var expandedClass = "".concat(prefix, "expanded");
    var toggleTimeout;
    var toggleExpand = function (expand) {
        if (expand === void 0) { expand = true; }
        clearTimeout(toggleTimeout);
        toggleTimeout = setTimeout(function () {
            if (expand) {
                expandEl.classList.add(expandedClass);
                closeEl.style.display = 'flex';
            }
            else {
                expandEl.classList.remove(expandedClass);
                closeEl.style.display = 'none';
            }
        }, 50);
    };
    closeEl.addEventListener('click', function () {
        var oneHourAway = new Date().getTime() + 1 * 60 * 60 * 1000;
        window.localStorage.setItem(dismissKey, oneHourAway + '');
        isVisible = false;
        updateContainer();
    });
    closeEl.addEventListener('mouseenter', function () { return toggleExpand(); });
    closeEl.addEventListener('mouseleave', function () { return toggleExpand(false); });
    expandEl.addEventListener('mouseenter', function () { return toggleExpand(); });
    expandEl.addEventListener('mouseleave', function () { return toggleExpand(false); });
    updateContainer();
}
function createContainer(prefix, icon, link) {
    if (link === void 0) { link = '#'; }
    var container = document.createElement('div');
    container.id = "".concat(prefix, "container");
    container.innerHTML = "\n        <button id=\"".concat(prefix, "close\" title=\"Hide Running Indicator\">\n            <span>\u00D7</span>\n        </button>\n        <a href=\"").concat(link, "\" target=\"_blank\" rel=\"noreferrer\">\n            <div id=\"").concat(prefix, "icon-wrapper\">\n                ").concat(icon, "\n                Mock Server Running\n            </div>\n        </a>\n    ");
    return container;
}
function createCss(prefix) {
    var css = document.createElement('style');
    css.textContent = "\n      #".concat(prefix, "container {\n        position: absolute;\n        display: none;\n        bottom: 15px;\n        left: 15px;\n      }\n      #").concat(prefix, "close {\n        top: -10px;\n        left: -10px;\n        border: none;\n        width: 18px;\n        height: 18px;\n        color: #333333;\n        font-size: 16px;\n        cursor: pointer;\n        display: none;\n        position: absolute;\n        background: #ffffff;\n        border-radius: 100%;\n        align-items: center;\n        flex-direction: column;\n        justify-content: center;\n      }\n      #").concat(prefix, "container a {\n        color: inherit;\n        text-decoration: none;\n        width: 40px;\n        height: 50px;\n        overflow: hidden;\n        border-radius: 5px;\n        background: #fff;\n        color: #000;\n        font: initial;\n        cursor: pointer;\n        letter-spacing: initial;\n        text-shadow: initial;\n        text-transform: initial;\n        visibility: initial;\n        font-size: 14px;\n        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n        padding: 5px 8px;\n        align-items: center;\n        box-shadow: 0 11px 40px 0 rgba(0, 0, 0, 0.25), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n        display: flex;\n        transition: opacity 0.1s ease, bottom 0.1s ease, width 0.3s ease;\n        animation: ").concat(prefix, "fade-in 0.1s ease-in-out;\n      }\n      #").concat(prefix, "icon-wrapper {\n        width: 140px;\n        height: 50px;\n        display: flex;\n        flex-shrink: 0;\n        align-items: center;\n        position: relative;\n      }\n      #").concat(prefix, "icon-wrapper svg {\n        flex-shrink: 0;\n        margin-right: 8px;\n      }\n      #").concat(prefix, "container a.").concat(prefix, "expanded {\n        width: 135px;\n      }\n      #").concat(prefix, "container.").concat(prefix, "visible {\n        display: flex;\n        bottom: 10px;\n        opacity: 1;\n      }\n      @keyframes ").concat(prefix, "fade-in {\n        from {\n          bottom: 0px;\n          opacity: 0;\n        }\n        to {\n          bottom: 10px;\n          opacity: 1;\n        }\n      }\n    ");
    return css;
}
